import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import PropTypes from 'prop-types';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from './images/close.svg';
import AlertIcon from './images/red-alert.svg';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    [theme.breakpoints.down('xs')]: {
      padding: '0 20px',
    },
  },
  container: {
    backgroundColor: theme.palette.bgColor.error,
    borderRadius: 8,
    padding: '16px',
    display: 'flex',
    alignItems: 'center',
    marginTop: 8,
    boxShadow: 'none',
    fontFamily: theme.typography.fontFamily,
  },
  icon: {
    marginRight: 16,
    minWidth: 24,
    minHeight: 24,
  },
  text: {
    color: theme.palette.text.error,
    fontSize: 16,
    fontWeight: 500,
    lineHeight: 1.5,
    flex: 1,
  },
  phone: {
    color: '#23395B',
    textDecoration: 'underline',
    cursor: 'pointer',
    fontWeight: 500,
  },
  closeButton: {
    marginLeft: 8,
    alignSelf: 'center',
    color: theme.palette.text.error,
    '&:hover': {
      backgroundColor: 'transparent',
    },
    '&:focus': {
      backgroundColor: 'transparent',
      outline: 'none',
    },
    '&:active': {
      backgroundColor: 'transparent',
    },
    '&.Mui-focusVisible': {
      backgroundColor: 'transparent',
    },
  },
}));

const CustomErrorMessage = ({ message, phone, error }) => {
  const classes = useStyles();
  const [open, setOpen] = useState(true);

  useEffect(() => {
    if (error) setOpen(true);
  }, [error]);

  if (!open) return null;

  return (
    <Box className={classes.root}>
      <Box className={classes.container} data-testid="blueshield-error-message">
        <img src={AlertIcon} alt="Error" className={classes.icon} />
        <span className={classes.text}>
          {message}
          {phone && (
            <>
              {' '}
              please call Customer Care at{' '}
              <a href={`tel:${phone}`} className={classes.phone}>
                {phone}
              </a>
            </>
          )}
        </span>
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={() => setOpen(false)}
          size="small"
        >
          <img src={CloseIcon} alt="Close" />
        </IconButton>
      </Box>
    </Box>
  );
};

CustomErrorMessage.propTypes = {
  message: PropTypes.string.isRequired,
  phone: PropTypes.string,
  error: PropTypes.any,
};

export default CustomErrorMessage;
